import { SVGProps } from 'react';

const SvgEarth = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<circle fill='currentColor' opacity={0.3} cx={12} cy={12} r={9} />
				<path
					d='M11.736 20.996a9 9 0 01-8.733-9.245c.66.063 1.853.206 1.91.67.077.64 0 1.44.545 1.68s.701-.96 1.169-.64c.467.32 1.714.629 1.714 1.195 0 .566-.234 1.447 0 1.608.234.16 1.168 1.28 1.168 1.44 0 .161.33.975.231 1.287-.08.258-.491 1.06-.89 1.424a8.742 8.742 0 002.886.581zM8.283 3.801A8.967 8.967 0 0112 3a9 9 0 018.036 4.944c.034.78.028 1.447.2 1.689.877 1.227-2.136 2.071-1.679 3.928.202.818-2.004.559-2.543 1.325-.54.767-1.857.252-2.162.104-.305-.147-1.475.344-1.373-.49.102-.835.813-.884 1.577-1.228.762-.343 1.863-1.485 1.322-1.634-2.546-.702-3.414-3.16-3.414-3.16-.153-.029-.115-1.737-.776-1.786-.661-.05-1.018.196-1.984 0s-.763-.835-.915-2.21c-.034-.308-.033-.525-.006-.68zm12.716 8.076L21 12a9 9 0 01-8.91 9c4.88-.05 8.844-4.112 8.91-9.123z'
					fill='currentColor'
					opacity={0.3}
				/>
			</g>
		</svg>
	);
};

export default SvgEarth;
